document.addEventListener("DOMContentLoaded", () => {
  const quizz = document.querySelector('.quizz-wrapper');
  
  if (quizz) {
    let quizzResponse = {
      "firstname": "",
      "sex": "",
      "zodiac": "",
      "ill-type": "",
      "ill": [],
      "email": "",
      "beads": []
    };

    const combinaisons = JSON.parse(localStorage.getItem('combinaisons'));
    
    const steps = quizz.querySelectorAll('[data-quizz-step]');
    const previousButtons = quizz.querySelectorAll('.quizz-previous, [data-quizz-start]');
    const submitButtons = quizz.querySelectorAll('[data-step-submit]');
    const quizzSubmit = quizz.querySelector('[data-quizz-submit]');

    const radioButtons = quizz.querySelectorAll('[name="zodiac"], [name="sex"], [name="ill-type"]');
    radioButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        const currentStep = btn.closest('[data-quizz-step]');
        const submitBtn = currentStep.querySelector('[data-step-submit]');
        submitBtn.dispatchEvent(new Event('click'));
      });
    });

    previousButtons.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const currentStep = btn.parentElement;
        const targetId = parseInt(btn.getAttribute('data-step-switch'));
        switchStep(currentStep, targetId);
      });
    });

    submitButtons.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const currentStep = btn.parentElement;
        const targetId = parseInt(btn.getAttribute('data-step-switch'));
        const name = btn.getAttribute('data-step-submit');

        if (stepIsValid(name)) {
          switchStep(currentStep, targetId);
        }
      });
    });

    quizzSubmit.addEventListener('click', function() {
      const emailInput = quizz.querySelector('[step-choices="email"] [name="email"]');
      const noEmailCheckbox = quizz.querySelector('#no-email');
      const klaviyoForm = quizz.querySelector('.klaviyo-form');

      if (noEmailCheckbox.checked) {
        validateQuizz();
        quizz.querySelector('[step-choices="email"]').classList.remove('error');
      } else if (emailInput.value !== '') {
        if (validateEmail(emailInput.value)) {
          quizzResponse['email'] = emailInput.value;
          quizz.querySelector('[step-choices="email"]').classList.remove('error');
          klaviyoForm.querySelector('[id*="email"]').value = emailInput.value;
          klaviyoForm.querySelector('[id*="email"]').dispatchEvent(new Event('input'));
          klaviyoForm.querySelector('form').dispatchEvent(new Event('submit'));
          validateQuizz();
        } else {
          quizz.querySelector('[step-choices="email"]').classList.add('error');
        }
      } else {
          quizz.querySelector('[step-choices="email"]').classList.add('error');
      }
    });

    function switchStep(currentStep, targetId) {
        const currentId = currentStep.getAttribute('data-quizz-step');
        const targetStep = quizz.querySelector('[data-quizz-step="' + targetId + '"]');
        const nextStep = quizz.querySelector('[data-quizz-step="' + (targetId + 1) + '"]');
        const previousStep = quizz.querySelector('[data-quizz-step="' + (targetId + 1) + '"]');

        if (currentId > targetId) {
          currentStep.classList.add('quizz-step--previous');
        }

        steps.forEach(step => {
          step.classList.add('quizz-step--hidden');

          setTimeout(function() {
            step.style.display = 'none';
            
            if (currentId > targetId) {
              currentStep.classList.add('quizz-step--previous');
            } else {
              targetStep.classList.add('quizz-step--next');
            }
            
            targetStep.style.display = 'flex';
          }, 500);
        });

        setTimeout(function() {
          targetStep.classList.remove('quizz-step--hidden');
          targetStep.classList.remove('quizz-step--next');
          currentStep.classList.remove('quizz-step--previous');

          if (nextStep) {
            nextStep.classList.add('quizz-step--next');
          }
        }, 600);
    }

    function stepIsValid(name) {
      let isValid = true;
      let errorMessage = '';
      const klaviyoForm = quizz.querySelector('.klaviyo-form');
      
      switch (name) {
        case 'firstname':
          const input = quizz.querySelector('[name="firstname"]');
          if (input.value == '') {
            isValid = false;
            input.classList.add('error');
          } else {
            quizzResponse.firstname = input.value;
            quizz.querySelector('[data-quizz-firstname]').innerHTML = input.value;
            klaviyoForm.querySelector('[id*="first_name"]').value = input.value;
            klaviyoForm.querySelector('[id*="first_name"]').dispatchEvent(new Event('input'));
          }
          break;
        case 'sex':
          isValid = checkChoice(name, 'Sexe');
          break;
        case 'zodiac':
          isValid = checkChoice(name, 'Zodiac_Sign');
          break;
        case 'ill-type':
          isValid = checkChoice(name);
          if (isValid) {
            const illChoices = quizz.querySelectorAll('[data-ill-type]');
            illChoices.forEach(ill => {
              ill.style.display = 'none';

              const illSex = ill.getAttribute('data-ill-sex');
              const illType = ill.getAttribute('data-ill-type');
              if (illSex.includes(quizzResponse['sex']) && (quizzResponse['ill-type'].includes(illType) || quizzResponse['ill-type'] == 'both')) {
                ill.style.display = 'block';
              }
            });
          }
          break;
        case 'ill':
          const selectedChoice = quizz.querySelectorAll('[name="' + name + '"]:checked');
          if (selectedChoice.length > 0 && selectedChoice.length < 5) {
            const total = [];
            let klaviyo_value = '';
            selectedChoice.forEach(choice => {
              total.push(choice.value);
              klaviyo_value = klaviyo_value + choice.value + ',';
            });
            quizzResponse[name] = total;
            klaviyoForm.querySelector('[id*="Maux"]').value = klaviyo_value;
            klaviyoForm.querySelector('[id*="Maux"]').dispatchEvent(new Event('input'));
          } else {
            isValid = false;
            quizz.querySelector('[step-choices="' + name + '"]').classList.add('error');
          }
          break;
        default:
      }

      return isValid;
    }

    function checkChoice(name, klaviyo_id = '') {
      const klaviyoForm = quizz.querySelector('.klaviyo-form');
      const selectedChoice = quizz.querySelector('[name="' + name + '"]:checked');
      let isValid = true;
      if (selectedChoice) {
        quizzResponse[name] = selectedChoice.value;
        if (klaviyo_id !== '') {
          if (klaviyoForm.querySelector('[id*="' + klaviyo_id + '"]')) {
            klaviyoForm.querySelector('[id*="' + klaviyo_id + '"]').value = selectedChoice.value;
            klaviyoForm.querySelector('[id*="' + klaviyo_id + '"]').dispatchEvent(new Event('input'));
          }
        }
      } else {
        isValid = false;
        quizz.querySelector('[step-choices="' + name + '"]').classList.add('error');
      }

      return isValid;
    }

    function validateEmail(email) {
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailPattern.test(email);
    }

    function validateQuizz() {
      const quizzFinal = quizz.querySelector('[data-quizz-final]');
      
      steps.forEach(step => {
        step.style.display = 'none';
      });
      quizzFinal.style.display = 'flex';

      setTimeout(function() {
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function() {
          if (xhr.readyState === XMLHttpRequest.DONE) {
            if (xhr.status === 200) {
              quizzFinal.innerHTML = JSON.parse(xhr.responseText)['quizz-response'];
              updateFinalData();
            } else {
              document.getElementById('responseData').textContent = "Une erreur s'est produite";
            }
          }
        };
  
        var url = '/?sections=quizz-response';
        xhr.open('GET', url, true);
        xhr.send();
      }, 1500);
    }

    function updateFinalData() {
      updateFinalBeads();
      initBracelet();
      updateCrosssells();
    }

    function findBead(ill, sex) {
      for (const [name, details] of Object.entries(combinaisons)) {
        if ((details.corps.includes(ill) || details.esprit.includes(ill)) && details.sex.includes(sex)) {
          return name;
        }
      }
      return null;
    }

    function updateFinalBeads() {
      const finalBeads = quizz.querySelector('.quizz-final-beads');
      finalBeads.innerHTML = '';
      quizzResponse['ill'].forEach(ill => {
        const beadName = findBead(ill, quizzResponse['sex']);
        const beadData = combinaisons[beadName];
        if (finalBeads.querySelector('[data-bead-name="' + beadName + '"]')) {
          const newLabel = document.createElement('span');
          newLabel.classList.add('quizz-final-bead-subtitle');
          newLabel.innerHTML = '(' + ill + ')';
          finalBeads.querySelector('[data-bead-name="' + beadName + '"]').append(newLabel);
        } else {
          const bead = document.createElement('div');
          bead.classList.add('quizz-final-bead');
          bead.setAttribute('data-bead-name', beadName);
          bead.innerHTML = `<img src="${beadData['image']}" alt="${ill}" class="quizz-final-bead-image" />
                            <strong class="quizz-final-bead-title">${beadName}</strong>
                            <span class="quizz-final-bead-subtitle">(${ill})</span>`;
          finalBeads.append(bead);
          quizzResponse['beads'].push(beadName);
        }
      });
    }

    function initBracelet() {
      const braceletWrapper = quizz.querySelector('.quizz-final-bracelet');
      
      const braceletSize = '17cm';
      const beadSize = '6mm';
      const beadsNumber = 31;

      const diametreBead = parseInt(beadSize) * 4;
      const diametreBracelet = (diametreBead * beadsNumber) / Math.PI;
      
      const centerX = diametreBracelet / 2;
      const centerY = diametreBracelet / 2;
  
      const dynamicBracelet = document.createElement('div');
      dynamicBracelet.classList.add('dynamic-bracelet');
      dynamicBracelet.setAttribute(
        'style', 
        '--bracelet-size:' + diametreBracelet + 'px;' +
        '--bead-size:' + diametreBead + 'px'
      );
      braceletWrapper.append(dynamicBracelet);

      for (let i = 0; i < beadsNumber; i++) {
        const angle = (i / beadsNumber) * Math.PI * 2;
        const x = centerX + (diametreBracelet / 2 ) * Math.cos(angle);
        const y = centerY + (diametreBracelet / 2 ) * Math.sin(angle);
        
        const bead = document.createElement('span');
        bead.classList.add('dynamic-bracelet__bead');
        bead.style.top = y - diametreBead / 2 + 'px';
        bead.style.left = x - diametreBead / 2 + 'px';
        
        dynamicBracelet.appendChild(bead);
      }
      
      initBraceletButton();
      updateBracelet();
    }

    function initBraceletButton() {
      const finalButton = quizz.querySelector('.quizz-final-button');
      const braceletLink = finalButton.getAttribute('href');
      const selectedBeads = quizzResponse['beads'];
      let newLink = braceletLink;
      
      if (selectedBeads[0]) {
        newLink = newLink + "?b1=" + selectedBeads[0];
      }
      if (selectedBeads[1]) {
        newLink = newLink + "&b2=" + selectedBeads[1];
      }
      if (selectedBeads[2]) {
        newLink = newLink + "&b3=" + selectedBeads[2];
      }
      if (selectedBeads[3]) {
        newLink = newLink + "&b4=" + selectedBeads[3];
      }

      finalButton.setAttribute('href', newLink);
    }

    function updateBracelet() {
      const beads = quizz.querySelectorAll('.dynamic-bracelet__bead');
      const beadsNumber = beads.length;
      let nextBeadType = 1;

      const selectedBeads = quizzResponse['beads'];

      let image1 = null;
      let image2 = null;
      let image3 = null;
      let image4 = null;
      
      if (selectedBeads[0]) {
        image1 = combinaisons[selectedBeads[0]]['image_bead'];
      }
      if (selectedBeads[1]) {
        image2 = combinaisons[selectedBeads[1]]['image_bead'];
      }
      if (selectedBeads[2]) {
        image3 = combinaisons[selectedBeads[2]]['image_bead'];
      }
      if (selectedBeads[3]) {
        image4 = combinaisons[selectedBeads[3]]['image_bead'];
      }
  
      beads.forEach(bead => {
        switch (nextBeadType) {
          case 1:
            if (image1) {
              bead.style.backgroundImage = 'url(' + image1 + ')';
            } else {
              bead.style.backgroundImage = 'none';
            }
            
            if (image2) {
              nextBeadType = 2;
            }
            break;
          case 2:
            bead.style.backgroundImage = 'url(' + image2 + ')';
            if (image3) {
              nextBeadType = 3;
            } else {
              nextBeadType = 1;
            }
            break;
          case 3:
            bead.style.backgroundImage = 'url(' + image3 + ')';
            if (image4) {
              nextBeadType = 4;
            } else {
              nextBeadType = 1;
            }
            break;
          case 4:
            bead.style.backgroundImage = 'url(' + image4 + ')';
            nextBeadType = 1;
            break;
        }
        
        bead.style.border = '0';
      });
    }

    function updateCrosssells() {
      const finalStep = quizz.querySelector('[data-quizz-final]');
      quizzResponse['beads'].forEach(bead => {
        const crosssell = document.createElement('div');
        crosssell.classList.add('quizz-final-crosssell');
        let html = `<strong class="quizz-final-crosssell-title">${bead}</strong>
              <div class="quizz-final-crosssell-products">`;
        
        combinaisons[bead]['cross_sells'].forEach(product => {
            html = html + `<a href="" class="quizz-final-crosssell-product">
                <img src="${product.thumbnail}" alt="${product.name}" class="quizz-final-crosssell-product-image" />
                <div class="quizz-final-crosssell-product-content">
                  <strong class="quizz-final-crosssell-product-name">${product.name}</strong>
                  <span class="quizz-final-crosssell-product-price">
                    <strong>${product.price}€</strong>`;
                    if (product.old_price) {
                     html = html + `<span class="quizz-final-crosssell-product-price-old">${product.old_price}€</span>`;
                    }
                  html = html + `</span>
                </div>
              </a>`;
        });

        html = html + `</div>
              <a href="${combinaisons[bead]['collection_url']}" class="quizz-final-crosssell-link">Voir toute la collection “${bead}”
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="512" height="512" viewBox="0 0 512 512">
                  <path fill="currentColor" d="M201.373 438.627l-160-160c-12.497-12.496-12.497-32.758 0-45.255l160-160c12.497-12.496 32.758-12.496 45.255 0s12.497 32.758 0 45.255l-105.373 105.373h306.745c17.673 0 32 14.327 32 32s-14.327 32-32 32h-306.745l105.373 105.373c6.248 6.248 9.372 14.438 9.372 22.627s-3.124 16.379-9.372 22.627c-12.497 12.497-32.758 12.497-45.255 0z"/>
                </svg>
              </a>`;

        crosssell.innerHTML = html;
        finalStep.append(crosssell);
      });
    }
  }
});